(function () {
  var track = document.querySelector('[data-occasion-track]');
  if (!track || track.children.length < 2) return;

  var index = 0;
  var cards = track.querySelectorAll('[data-occasion-card]');
  var delay = parseInt(track.getAttribute('data-interval') || '5000', 10);
  var timerId = null;
  var paused = false;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollToCard(i) {
    var card = cards[i];
    var behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';
    track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: behavior });
  }

  function advance() {
    index = (index + 1) % cards.length;
    scrollToCard(index);
  }

  function startTimer() {
    if (prefersReducedMotion.matches) return;
    stopTimer();
    timerId = setInterval(advance, delay);
  }

  function stopTimer() {
    if (timerId) {
      clearInterval(timerId);
      timerId = null;
    }
  }

  // Pause on hover / focus
  track.addEventListener('mouseenter', function () { paused = true; stopTimer(); });
  track.addEventListener('mouseleave', function () { paused = false; startTimer(); });
  track.addEventListener('focusin', function () { paused = true; stopTimer(); });
  track.addEventListener('focusout', function () { paused = false; startTimer(); });

  // Nav buttons
  var prev = document.querySelector('[data-occasion-prev]');
  var next = document.querySelector('[data-occasion-next]');

  if (prev) {
    prev.addEventListener('click', function () {
      index = (index - 1 + cards.length) % cards.length;
      scrollToCard(index);
      stopTimer();
      if (!paused) startTimer();
    });
  }
  if (next) {
    next.addEventListener('click', function () {
      index = (index + 1) % cards.length;
      scrollToCard(index);
      stopTimer();
      if (!paused) startTimer();
    });
  }

  // Respect motion preference changes
  prefersReducedMotion.addEventListener('change', function () {
    if (prefersReducedMotion.matches) {
      stopTimer();
    } else if (!paused) {
      startTimer();
    }
  });

  startTimer();
})();
